import lottie from "lottie-web/build/player/lottie_light";

export function initLottie($) {
  // Solution Types: render local Lottie animations in place of videos.
  function initialize(container) {
    const card = container.closest(".solution-types_wrap");
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const returnSpeed = 1.6;
    let isHovered = card?.matches(":hover") || false;
    let direction = 1;
    const animation = lottie.loadAnimation({
      container,
      renderer: "svg",
      loop: false,
      autoplay: false,
      path: container.dataset.lottieSrc,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid meet",
      },
    });
  
    animation.addEventListener("DOMLoaded", function () {
      const svg = container.querySelector("svg");
      if (svg) {
        // Keep every animation the same width, but preserve its own aspect ratio.
        // Taller files may extend above the shared 740:346 layout slot.
        svg.style.width = "100%";
        svg.style.height = "auto";
      }
      animation.goToAndStop(0, true);
      if (isHovered && !reduceMotion) animation.play();
    });

    animation.addEventListener("complete", function () {
      if (!isHovered) {
        direction = 1;
        animation.setDirection(direction);
        animation.setSpeed(1);
        animation.goToAndStop(0, true);
        return;
      }

      // While hovered, alternate between a normal forward play and a quicker
      // return to the first frame. This avoids the hard end-to-start loop cut.
      direction *= -1;
      animation.setDirection(direction);
      animation.setSpeed(direction === -1 ? returnSpeed : 1);
      animation.play();
    });
  
    if (!card) return;
  
    card.addEventListener("mouseenter", function () {
      isHovered = true;
      direction = 1;
      animation.setDirection(direction);
      animation.setSpeed(1);
      if (!reduceMotion) {
        animation.play();
      }
    });
  
    card.addEventListener("mouseleave", function () {
      isHovered = false;

      if (!reduceMotion) {
        direction = -1;
        animation.setDirection(direction);
        animation.setSpeed(returnSpeed);
        animation.play();
      }
    });
  }

  const containers = document.querySelectorAll('.solution-types_lottie[data-lottie-src]');
  if (!('IntersectionObserver' in window)) {
    containers.forEach(initialize);
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      initialize(entry.target);
    });
  }, { rootMargin: '200px' });
  containers.forEach((container) => observer.observe(container));
}
